/* eslint-disable react/jsx-filename-extension */
import React, { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import Loading from './Loading';
import ARPromotion from './catalog/ARPromotion';

import './index.css';

const Andwin = React.lazy(() => import('./sites/andwin/App'));
const Azer = React.lazy(() => import('./sites/azer/App'));
const BSI = React.lazy(() => import('./sites/bsi/App'));
const BlueRidge = React.lazy(() => import('./sites/blueridge/App'));
const Cleanroom = React.lazy(() => import('./sites/cleanroom/App'));
const DAI = React.lazy(() => import('./sites/dai/App'));
const Daigger = React.lazy(() => import('./sites/daigger/App'));
const Define = React.lazy(() => import('./sites/define/App'));
const DSI = React.lazy(() => import('./sites/dsi/App'));
const Ecom = React.lazy(() => import('./sites/ecom/App'));
const EcomTMP = React.lazy(() => import('./sites/ecom2/App'));
const Farnell = React.lazy(() => import('./sites/farnell/App'));
const Fisher = React.lazy(() => import('./sites/fisher/App'));
const FisherEd = React.lazy(() => import('./sites/fishered/App'));
const Genesee = React.lazy(() => import('./sites/genesee/App'));
const GSS = React.lazy(() => import('./sites/gss/App'));
const GMI = React.lazy(() => import('./sites/gmi/App'));
const H2I = React.lazy(() => import('./sites/h2i/App'));
const Herr = React.lazy(() => import('./sites/herr/App'));
const Kewaunee = React.lazy(() => import('./sites/kewaunee/App'));
const Kloeppel = React.lazy(() => import('./sites/kloeppel/App'));
const LabRepCo = React.lazy(() => import('./sites/labrepco/App'));
const LBI = React.lazy(() => import('./sites/lbi/App'));
const LOC = React.lazy(() => import('./sites/loc/App'));
const LPS = React.lazy(() => import('./sites/lps/App'));
const MGLab = React.lazy(() => import('./sites/mglabsolutions/App'));
const Midland = React.lazy(() => import('./sites/midland/App'));
const Nelson = React.lazy(() => import('./sites/nelson/App'));
const Nova = React.lazy(() => import('./sites/nova/App'));
const Nowak = React.lazy(() => import('./sites/nowak/App'));
const Nycom = React.lazy(() => import('./sites/nycom/App'));
const Nurnberg = React.lazy(() => import('./sites/nurnberg/App'));
const OfficePlanners = React.lazy(() => import('./sites/officeplanners/App'));
const OnePointe = React.lazy(() => import('./sites/onepointe/App'));
const Proline = React.lazy(() => import('./sites/proline/App'));
const QALine = React.lazy(() => import('./sites/qaline/App'));
const Scott = React.lazy(() => import('./sites/scott/App'));
const Spectrum = React.lazy(() => import('./sites/spectrum/App'));
const SpectrumRX = React.lazy(() => import('./sites/spectrumrx/App'));
const Stellar = React.lazy(() => import('./sites/stellar/App'));
const SCI = React.lazy(() => import('./sites/sci/App'));
const Superior = React.lazy(() => import('./sites/superior/App'));
const Taylor = React.lazy(() => import('./sites/taylor/App'));
const Thermal = React.lazy(() => import('./sites/thermal/App'));
const Thomas = React.lazy(() => import('./sites/thomas/App'));
const Technimark = React.lazy(() => import('./sites/technimark/App'));
const Omnilab = React.lazy(() => import('./sites/omnilab/App'));
const Phillocraft = React.lazy(() => import('./sites/phillocraft/App'));
const Biologix = React.lazy(() => import('./sites/biologix/App'));
const Labpro = React.lazy(() => import('./sites/labpro/App'));
const Emerald = React.lazy(() => import('./sites/emerald/App'));
const Test = React.lazy(() => import('./sites/test/App'));
const EcomIframe = React.lazy(() => import('./sites/ecom iframe/App'));
const EcomSubdomain = React.lazy(() => import('./sites/ecom2/App'));
const Standard = React.lazy(() => import('./sites/standard/App'));
const Br = React.lazy(() => import('./sites/br_template/App'));

const { hostname, ancestorOrigins } = window.location;
const HOST_APP_MAP = {
  'catalog.localhost': { Component: Ecom },
  'testing.ecomseating.com': { Component: Test },
  'lablanding.netlify.app': { Component: EcomTMP },
  'testing.labtechseating.com': { Component: Ecom },
  'seating.bsilab.com': { Component: BSI },
  'seating.gmi-inc.com': { Component: GMI },
  'seating.nurnberg.com': { Component: Nurnberg },
  'chairs.superiorstoragesystems.com': { Component: Superior },
  'chairs.cleanroomsupplies.com': { Component: Cleanroom },
  'seating.labrepco.com': { Component: LabRepCo },
  'seating.labdepotinc.com': { Component: Standard, props: { partner: 'labdepot' } },
  'taylor.ecomseating.com': { Component: Taylor },
  'qaline.ecomseating.com': { Component: QALine },
  'seating.novatech-usa.com': { Component: Nova },
  'nowak.ecomseating.com': { Component: Nowak },
  'nelson.ecomseating.com': { Component: Nelson },
  'chairs.nelsonjameson.com': { Component: Nelson },
  'bsi.ecomseating.com': { Component: BSI },
  'seating.blueridgeergonomics.com': { Component: BlueRidge },
  'seating.daiscientific.com': { Component: DAI },
  'daiggerlabchairs.com': { Component: Daigger },
  'dsi.ecomseating.com': { Component: DSI },
  'define.ecomseating.com': { Component: Define },
  'chairs.andwinsci.com': { Component: Andwin },
  'seating.omnilabsolutions.com': { Component: Omnilab },
  '1prolineseating.com': { Component: Proline },
  'seating.geneseesci.com': { Component: Genesee },
  'gsschair.govsci.com': { Component: GSS },
  'catalog.scottlaboratorysolutions.com': { Component: Scott },
  'seating.scottlaboratorysolutions.com': { Component: Scott },
  'spectrum.ecomseating.com': { Component: Spectrum },
  'spectrumrx.ecomseating.com': { Component: SpectrumRX },
  'seating.stellarscientific.com': { Component: Stellar },
  'seating.srsonline.com': { Component: Standard, props: { partner: 'srs' } },
  'chairs.scisale.com': { Component: SCI },
  'thermal.ecomseating.com': { Component: Thermal },
  'thomaschair.com': { Component: Thomas },
  'thomasscichair.com': { Component: Thomas },
  'www.thomasscichair.com': { Component: Thomas },
  'www.thomaschair.com': { Component: Thomas },
  'seating.kewaunee.com': { Component: Kewaunee },
  'seating.instocklabs.com': { Component: LBI },
  'catalog.locinc.com': { Component: LOC },
  'labdepot.ecomseating.com': { Component: Standard, props: { partner: 'labdepot' } },
  'catalog.midlandsci.com': { Component: Standard, props: { partner: 'midland' } },
  'catalog.officeplanners.com': { Component: OfficePlanners },
  'chairs.onepointesolutions.com': { Component: OnePointe },
  'test.ecomseating.com': { Component: EcomIframe },
  'catalog.ecomseating.com': { Component: EcomSubdomain },
  'ecomseating.com': { Component: Ecom },
  'www.ecomseating.com': { Component: Ecom },
  'seating.kloeppel.com': { Component: Kloeppel },
  'labfurniture.mglabsolutions.com': { Component: MGLab },
  'catalog.nycominc.com': { Component: Nycom },
  'seating.nycominc.com': { Component: Nycom },
  'farnell.ecomseating.com': { Component: Farnell },
  'chairs.labproservices.com': { Component: LPS },
  'seating.phillocraft.com': { Component: Phillocraft },
  'seating.biologix.store': { Component: Biologix },
  'seating.emeraldscientific.com': { Component: Emerald },
  'seating.labproinc.com': { Component: Br, props: { partner: 'labpro' } },
  'seating.iciscientific.com':{ Component: Standard, props: { partner: 'ici' } },
  'chairs.aresscientific.com': { Component: Standard, props: { partner: 'ares' } },
  'seating.medsupplypartners.com': { Component: Standard, props: { partner: 'medsupply' } },
  'seating.labbuild.com': { Component: Standard, props: { partner: 'labbuild' } },
  'chairs.scilogex.com': { Component: Standard, props: { partner: 'scilogex' } },
  'seating.canadianscientific.ca': { Component: Standard, props: { partner: 'csi' } },
  'chairs.krackeler.com': { Component: Standard, props: { partner: 'krackeler' } },
  'seating.symbiote.com': { Component: Standard, props: { partner: 'symbiote' } },
  'chairs.airmastersystems.com': { Component: Standard, props: { partner: 'airmaster' } },
  'seating.yamato-usa.com': { Component: Standard, props: { partner: 'yamato' } },
  'labchairs.azerscientific.com': { Component: Azer },
  'chairs.hansonlab.com': { Component: Standard, props: { partner: 'hanson' } },
  'seating.saisns.com': { Component: Br, props: { partner: 'maple' } },
  'seating.haldemanhomme.com': { Component: H2I },
  'fisher.localhost': { Component: Fisher },
  'fisher.ecomseating.com': { Component: Fisher },
  'fisherchair.com': { Component: Fisher },
  'www.fisherchair.com': { Component: Fisher },
  'fisherchairs.com': { Component: Fisher },
  'www.fisherchairs.com': { Component: Fisher },
  'fishered.localhost': { Component: FisherEd },
  'fisheredchair.com': { Component: FisherEd },
  'www.fisheredchair.com': { Component: FisherEd },
  'catalog.fisherchair.com': { Component: FisherEd },
  'fisheredchairs.com': { Component: FisherEd },
  'www.fisheredchairs.com': { Component: FisherEd },
  'education.fisherchair.com': { Component: FisherEd },
};

const getAppForHost = (host) => {
  const entry = HOST_APP_MAP[host];
  if (!entry) {
    return null;
  }
  const { Component, props } = entry;
  return <Component {...props} />;
};

const ancestorOrigin = ancestorOrigins && ancestorOrigins.length ? ancestorOrigins[0] : null;
const app = getAppForHost(hostname)
  || (ancestorOrigin === 'https://technimark-inc.com' ? <Technimark /> : null)
  ||<EcomIframe/>

function AppWrapper() {
  const isHomepage = window.location.pathname === '/';

  return (
    <>
      {isHomepage && <ARPromotion />}
      <React.Suspense fallback={<Loading />}>{app}</React.Suspense>
    </>
  );
}

const root = createRoot(document.getElementById('root'));
root.render(<StrictMode><AppWrapper /></StrictMode>);
